// extracted by mini-css-extract-plugin
export default {"cSwitch":"cSwitch-BE3vq","cSwitchCircle":"cSwitch-circle-JMT_t","cSwitchOpen":"cSwitch-open-pXeIl","cSwitchClose":"cSwitch-close-tFxw7"};